import { Component, ComponentOptions } from "./component";

export interface ContentContainerOptions extends ComponentOptions {
    property: string;
}

export class ContentContainer extends Component {

    options: ContentContainerOptions;

    constructor(options: ContentContainerOptions) {
        super(options);
    }

    generate(): string {
        var components = this.contentRoot.content[this.options.property];
        return this.contentRoot.generateContentForComponents(components);
    }

}
